<template>
  <div>
    <el-button-group v-show="!disabled">
      <el-button
        type="primary"
        size="mini"
        icon="el-icon-edit"
        @click="fromLoad('add')"
        >新增</el-button
      >
    </el-button-group>
    <el-table
      :data="tableData"
      v-loading="loading"
      @selection-change="handleSelectionChange"
      stripe
      size="mini"
      :height="height"
    >
      <el-table-column
        :show-overflow-tooltip="true"
        align="left"
        header-align="left"
        label="序号"
        width="55"
      >
        <template slot-scope="scope">
          <el-link type="primary" @click="fromLoad('detail', scope.row)">{{
            scope.row.seqno
          }}</el-link>
        </template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="left"
        header-align="left"
        prop="projectRoleName"
        label="项目角色中文"
        width="100"
      ></el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="left"
        header-align="left"
        prop="personName"
        label="参与人姓名"
        width="100"
      ></el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="left"
        header-align="left"
        prop="personMobile"
        label="参与人手机"
        width="100"
      ></el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="left"
        header-align="left"
        prop="personPhone"
        label="固定电话"
        width="140"
      ></el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="left"
        header-align="left"
        prop="personEmail"
        label="参与人Email"
        width="140"
      ></el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="left"
        header-align="left"
        prop="personJob"
        label="参与人职务"
        width="100"
      ></el-table-column>
      <el-table-column
        v-if="!disabled"
        label="操作"
        width="130"
        fixed="left"
        align="center"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            style="padding:5px;"
            icon="el-icon-edit-outline"
            @click="fromLoad('edit', scope.row)"
          />
          <el-button
            size="mini"
            style="padding:5px;"
            type="danger"
            @click="del(scope.row.participantCode)"
            icon="el-icon-delete"
          ></el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
      ref="formDialog"
      :title="formOption.title"
      :visible.sync="formOption.dialogFormVisible"
      :before-close="cancel"
      :close-on-click-modal="false"
      width="350px"
    >
      <page-detail ref="form" @success="saveSuccess"></page-detail>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel" size="small">取 消</el-button>
        <el-button
          type="primary"
          @click="save"
          size="small"
          v-show="!formOption.disabled"
          >保 存</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      ref="addFormDialog"
      title="添加"
      :visible.sync="formOption.dialogAddFormVisible"
      :before-close="cancel"
      :close-on-click-modal="false"
      width="950px"
    >
      <page-add ref="addForm" :params="params"></page-add>
      <div></div>
      <el-form ref="addFormItem" :model="addForm">
        <el-form-item
          prop="projectRole"
          label="项目角色"
          :rules="{
            required: true,
            message: '请选择项目角色',
            trigger: 'blur',
          }"
        >
          <dict-select
            size="mini"
            v-model="addForm.projectRole"
            url="/digitalCenter/common/dict/system"
            :body="{ dictType: 'projectRole' }"
            placeholder="请选择项目角色"
            clearable
            filterable
          ></dict-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel" size="small">取 消</el-button>
        <el-button type="primary" @click="add" size="small">添 加</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// import { addApi, delApi } from '@api/projectManager/infoParticipant'
export default {
  props: {
    params: {
      default: null,
      type: Object,
    },
    tableData: {
      default: () => [],
    },
    disabled: {
      default: true,
      type: Boolean,
    },
    loading: {
      default: false,
    },
    height: {
      default: '',
      type: String || Number,
    },
  },
  components: {
    PageDetail: () => import('../detail/index'),
    PageAdd: () => import('../add/index'),
  },
  data() {
    return {
      // 表单设置
      formOption: {
        title: '',
        dialogFormVisible: false,
        dialogAddFormVisible: false,
        disabled: false,
        data: {},
      },
      // 选中的数据
      multipleSelection: [],
      addForm: {
        projectRole: '',
      },
    }
  },
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 加载表单
    fromLoad(ref, val = '') {
      const opt = {
        add: '新增',
        edit: '编辑',
        detail: '详情',
      }
      if (ref === 'add') {
        // 显示表单
        this.formOption.dialogAddFormVisible = true
        setTimeout(() => {
          // 调用组件表单加载方法
          this.$refs.addForm.load()
        }, 0)
      } else {
        this.formOption = {
          title: opt[ref],
          disabled: ref === 'detail',
          dialogFormVisible: true,
          data: val,
        }
        setTimeout(() => {
          // 调用组件表单加载方法
          this.$refs.form.fromLoad(this.formOption)
        }, 0)
      }
    },
    del(val) {
      this.$confirm('是否删除？').then((_) => {
        this.$api
          .infoParticipantDelApi({
            participantCode: val,
            prjCode: this.params.prjCode,
          })
          .then((res) => {
            this.$message({
              showClose: true,
              message: '删除成功',
              type: 'success',
            })
            this.$emit('submit')
          })
      })
    },
    add() {
      this.$refs.addFormItem.validate((valid) => {
        if (valid) {
          let data = this.$refs.addForm.selected
          if (!data || data.length < 1) {
            this.$message({
              showClose: true,
              message: '请选择参与人员',
              type: 'warning',
            })
            return
          }
          if (data.length > 1) {
            this.$message({
              showClose: true,
              message: '一次只能添加一个参与人员',
              type: 'warning',
            })
            return
          }
          data = data.map((item) => {
            return {
              prjCode: this.params.prjCode,
              personUserCode: item.userCode,
              personName: item.userNameEn,
              personMobile: item.mobileNumber,
              personPhone: item.fixedTelephone,
              personEmail: item.emailAddress,
              personJob: item.userPost,
              ...this.addForm,
            }
          })
          this.$api.infoParticipantAddApi(data[0]).then((res) => {
            this.$message({
              showClose: true,
              message: '添加成功',
              type: 'success',
            })
            this.saveSuccess()
          })
        }
      })
    },
    save() {
      this.$refs.form.save()
    },
    saveSuccess() {
      this.cancel()
      this.$emit('submit')
    },
    cancel() {
      this.formOption = {
        title: '',
        dialogFormVisible: false,
        dialogAddFormVisible: false,
        disabled: false,
        data: {},
      }
    },
  },
}
</script>
